module.exports = __webpack_public_path__ + "img/c02_unitpriestofset_Normal_ua.ca3ee44b.webp";